const labelCls = "block text-xs font-medium uppercase tracking-[0.15em] text-slate-400 mb-2";
const inputCls =
  "w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-white placeholder:text-slate-500 outline-none transition-colors duration-300 focus:border-sky-400/70 focus:bg-white/[0.06]";

export const TextField = ({ label, name, type = "text", required, value, onChange, placeholder, testId }) => (
  <div>
    {label && (
      <label htmlFor={name} className={labelCls}>
        {label} {required && <span className="text-sky-400">*</span>}
      </label>
    )}
    <input
      id={name}
      name={name}
      type={type}
      required={required}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={inputCls}
      data-testid={testId}
    />
  </div>
);

export const TextArea = ({ label, name, required, value, onChange, placeholder, rows = 4, testId }) => (
  <div>
    {label && (
      <label htmlFor={name} className={labelCls}>
        {label} {required && <span className="text-sky-400">*</span>}
      </label>
    )}
    <textarea
      id={name}
      name={name}
      required={required}
      rows={rows}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={inputCls}
      data-testid={testId}
    />
  </div>
);

export const SelectField = ({ label, name, required, value, onChange, options, testId }) => (
  <div>
    {label && (
      <label htmlFor={name} className={labelCls}>
        {label} {required && <span className="text-sky-400">*</span>}
      </label>
    )}
    <select
      id={name}
      name={name}
      required={required}
      value={value}
      onChange={onChange}
      className={`${inputCls} appearance-none bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22none%22 viewBox=%220 0 24 24%22 stroke=%22%2394a3b8%22><path stroke-linecap=%22round%22 stroke-linejoin=%22round%22 stroke-width=%222%22 d=%22M19 9l-7 7-7-7%22/></svg>')] bg-[length:18px] bg-[right_1rem_center] bg-no-repeat pr-10`}
      data-testid={testId}
    >
      <option value="" className="bg-ink-800">Select...</option>
      {options.map((o) => (
        <option key={o} value={o} className="bg-ink-800">
          {o}
        </option>
      ))}
    </select>
  </div>
);
